import { type JSX, FC, PropsWithChildren, useContext } from 'react';

import { CarouselContext } from './Carousel';
import { carouselItemRecipe } from './CarouselItem.css';
import { getClassNames } from '../../util/css';

type CarouselItemProps = {
  ariaLabel?: string;
  as?: Extract<keyof JSX.IntrinsicElements, 'div' | 'span' | 'li'>;
  className?: never;
};
const sparkyClassName = 'sparky-carousel-item';

export const CarouselItem: FC<PropsWithChildren<CarouselItemProps>> = ({
  children,
  ariaLabel,
  as: TagName = 'div',
  className = '',
}) => {
  const context = useContext(CarouselContext);
  const carouselItemClassNames = getClassNames(carouselItemRecipe(context), sparkyClassName, className);
  if (context === undefined) {
    throw new Error(`CarouselItem must be used within a Carousel.`);
  }

  return (
    <TagName aria-label={ariaLabel} tabIndex={0} className={carouselItemClassNames}>
      {children}
    </TagName>
  );
};
